import { CircleOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function EmptyState () {
  const { t } = useTranslation()
  return (
    <div className='w-full h-full min-h-32 flex justify-center items-center border-2 border-dashed rounded-2xl border-gray-200 gap-3 bg-gray-50'>
      <CircleOff size={22} className='text-gray-500' />
      <h2 className="text-gray-500">{t('workspaceUsagePage:No data')}</h2>
    </div>
  )
}
